import Tobii from "tobii";
import Blazy from "blazy";
import getAverageColor from "./averageColor";

const html = document.querySelector("html");
const body = document.querySelector("body");
body.classList.add("js");

if (document.querySelectorAll(".lightbox").length > 0) {
  new Tobii();
}
//
// if (backgroundColor.toLowerCase() == 'secondary') {
//   var link = document.querySelectorAll("menu-item.level-1  > a");
//   var logo = document.querySelectorAll(".logoTF");
//
//   for (var i = 0; i < logo.length; i++) {
//     logo[1].classList.add('d-block');
//     logo[1].classList.remove('d-none');
//   }
// }
// //else if Groen
// if (backgroundColor.toLowerCase() == 'primary') {
//   var logo = document.querySelectorAll(".logoTF");
//   for (var i = 0; i < logo.length; i++) {
//     logo[0].classList.add('d-block');
//     logo[0].classList.remove('d-none');
//   }
// }

//if dark
//if pageheader
var link = document.querySelectorAll(".menu-item.level-1");
var magnify = document.querySelectorAll('.menu-primary form .iconify')[0];

Array.from(link).map(function(l) {
  if (l.classList.contains('text-dark')) {
    magnify.setAttribute('style', 'color: #2D2D2D !important');
  }
});

new Blazy({selector: ".lazy", successClass: "loaded", success: function(element) {}});

/** Toggle the mobile menu
* @returns {void}
*/
function toggleMobileMenu() {
  html.classList.toggle("menu-opened");
  var mobileBar = document.getElementsByClassName("mobile-bar")[0];
  var logoWhite = document.querySelectorAll('.logoTF')[3];
  var mobileLogo = document.getElementsByClassName('mobilelogo')[0];

  if (html.classList.contains('menu-opened')) {
    Array.from(document.querySelectorAll(".menu-toggler > span")).map(function(l) {
      l.setAttribute('style', 'background: white !important');
      mobileBar.setAttribute('style', 'background:transparent !important');

      if (window.innerWidth < 600) {
        mobileLogo.style.display = 'none';
      }

    })
  } else {
    document.querySelectorAll(".menu-toggler > span").style = '';
    Array.from(document.querySelectorAll(".menu-toggler > span")).map(function(l) {
      l.style.background = '';
      mobileLogo.style.display = '';
      mobileBar.style.background = "";

    })

  }
}

document.querySelector(".menu-toggler").addEventListener("click", function(e) {
  e.preventDefault();
  toggleMobileMenu();
}, false);

if (document.querySelector(".search-toggler")) {
  document.querySelector(".search-toggler").addEventListener("click", function(e) {

    e.preventDefault();

    if (document.getElementById("mobileSearch")) {
      var mobileSearchEl = document.getElementById("mobileSearch");
    }

    if (html.classList.contains("menu-opened")) {
      mobileSearchEl.focus();
    } else {
      html.classList.add("menu-opened");
      mobileSearchEl.focus();
    }

    return false;
  }, false);
}

/** calculate the height of the mobile bar
 * @returns {void} nothin
 */
function calcMobileBarHeight() {
  let mobileBar = document.querySelector(".mobile-bar");
  let mobileMenu = document.querySelector(".mobile-menu");
  body.style.paddingTop = mobileBar.offsetHeight + "px";
  mobileMenu.style.paddingTop = mobileBar.offsetHeight + "px";
}

window.addEventListener("resize", calcMobileBarHeight);
window.addEventListener("load", calcMobileBarHeight);

const myTabs = document.querySelectorAll("ul.nav-tabs > li > a");
const panes = document.querySelectorAll(".tab-pane");
const tabAction = Object.keys(myTabs).map((tab) => {
  myTabs[tab].addEventListener("click", (e) => {

    makeInactive(myTabs);
    activateTab(e);
    makeInactive(panes);
    activateTabContent(e);

    e.preventDefault();
  });
});
/*
    *Makes a tab and it's content incactive
    */
function makeInactive(items) {

  const content = Object.keys(items).map((item) => {
    items[item].classList.remove("active");
  });

}
/*
     *Display the selected tab.
     */
function activateTab(e) {

  //refers to the element whose event listener triggered the event
  const clickedTab = e.currentTarget;
  clickedTab.classList.add("active");

}

/*
   * Display the selected tab content.
   */
function activateTabContent(e) {

  // gets the element on which the event originally occurred
  const anchorReference = e.target;
  const activePaneID = anchorReference.getAttribute("href");
  const activePane = document.querySelector(activePaneID);
  activePane.classList.add("active");

}

window.onscroll = function() {
  var scroll = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
  document.documentElement.style.setProperty('--scroll-var', scroll + "px");
}

var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;

  // var searchLang = document.getElementsByClassName("searchLang")[0];
  var siteHeader = document.getElementsByClassName('site-header')[0];

  //mobileMenu
  var mobileBar = document.getElementsByClassName("mobile-bar")[0];

  if (currentScrollPos > 200) {
    mobileBar.classList.remove('bg-transparent');
    mobileBar.classList.add('bg-light');
  } else {

    if (!document.body.classList.contains('bg-primary')) {
      mobileBar.classList.add('bg-transparent');
      mobileBar.classList.remove('bg-light');
    }

  }

  //if pageheader
  if (document.getElementsByClassName('page-header')[0]) {
    var pageHeader = document.getElementsByClassName('page-header')[0];
    var link = document.querySelectorAll(".menu-primary > .menu >.menu-item.level-1");
    var searchbar = document.querySelectorAll('.menu-primary form input')[0];
    var magnify = document.querySelectorAll('.menu-primary form .iconify')[0];
    var logoDark = document.querySelectorAll('.logoTF.dark')[0];
    var logoTFz = document.querySelectorAll('.logoTFz')[0];

    if (document.querySelectorAll('.menu-primary .level-1.current.text-white > a')[0]) {
      var active = document.querySelectorAll('.menu-primary .level-1.current.text-white > a')[0];
    }


    if (currentScrollPos > 200) {
      Array.from(link).map(function(l) {
        if (l.classList.contains('text-white')) {
          l.setAttribute('style', 'color: #2D2D2D !important');
          searchbar.setAttribute('style', 'border-color: #2D2D2D !important');
          magnify.setAttribute('style', 'color: #2D2D2D !important');

          if (document.querySelectorAll('.menu-primary .level-1.current.text-white > a')[0]) {
            active.setAttribute('style', 'border-color: #2D2D2D !important');
          }
          logoDark.classList.remove('d-none');

          if (logoTFz) {
            logoTFz.classList.add('d-none');
          }

        }

      })
      siteHeader.classList.remove('bg-transparent');
      siteHeader.classList.add('bg-' + backgroundColor.toLowerCase());

    } else {
      siteHeader.classList.add('bg-transparent');
      siteHeader.classList.remove('bg-' + backgroundColor.toLowerCase());
      logoDark.classList.add('d-none');

      if (logoTFz) {
        logoTFz.classList.remove('d-none');
      }

      Array.from(link).map(function(l) {
        if (l.classList.contains('text-white')) {
          l.style.color = "";
          searchbar.style.borderColor = "";
          magnify.style.color = "";

          if (document.querySelectorAll('.menu-primary .level-1.current.text-white > a')[0]) {
            active.style.borderColor = '';
          }
        }
      });

    }
  }

  if (!document.getElementsByClassName('page-header-image')[0] && !document.getElementById('news')  && !document.getElementById('article') ) {
    if (currentScrollPos > 200) {
      siteHeader.classList.remove('bg-transparent');
      siteHeader.classList.add('bg-' + backgroundColor.toLowerCase());
      if (backgroundColor.toLowerCase() == "secondary") {
        var link = document.querySelectorAll(".menu-primary > .menu >.menu-item.level-1 > a");
        for (var i = 0; i < link.length; i++) {
          link[i].classList.add('text-dark');
        }
        var logo = document.querySelectorAll(".logoTF");
        for (var i = 0; i < logo.length; i++) {
          logo[1].classList.add('d-block');
          logo[1].classList.remove('d-none');
          logo[2].classList.remove('d-block');
          logo[2].classList.add('d-none');
          logo[0].classList.remove('d-block');
          logo[0].classList.add('d-none');
        }
      } else if (backgroundColor.toLowerCase() == "primary") {
        var link = document.querySelectorAll(".menu-primary > .menu >.menu-item.level-1 > a");
        for (var i = 0; i < link.length; i++) {
          link[i].classList.add('text-white');
        }
        var logo = document.querySelectorAll(".logoTF");
        for (var i = 0; i < logo.length; i++) {
          logo[i].classList.add('d-none');
          logo[i].classList.remove('d-block');
          logo[0].classList.add('d-block');
        }
      }
    } else {
      siteHeader.classList.add('bg-transparent');
      siteHeader.classList.remove('bg-' + backgroundColor.toLowerCase());
      if (backgroundColor.toLowerCase() == 'secondary') {
        var logo = document.querySelectorAll(".logoTF");
        for (var i = 0; i < logo.length; i++) {
          logo[i].classList.add('d-none');
          logo[i].classList.remove('d-block');
          logo[1].classList.add('d-block');
        }
      } else if (backgroundColor.toLowerCase() == 'primary') {
        var logo = document.querySelectorAll(".logoTF");
        for (var i = 0; i < logo.length; i++) {
          logo[i].classList.add('d-none');
          logo[i].classList.remove('d-block');
          logo[0].classList.add('d-block');
        }
      }
    }
  }

  //ctafloat making sure it gets the correct position
  if (document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('page-header-title')[0] ||document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('form-container')[0] ) {
    var cta = document.getElementsByClassName('ctas')[0];
    var text = document.getElementsByClassName('main-text')[0];
    var leftPos = parseInt(cta.offsetLeft);
    var containerCta = document.getElementsByClassName('container-cta')[0];
    var footer = document.getElementsByClassName('site-footer')[0];
    var calcFooter = parseInt(footer.offsetTop - footer.offsetHeight);
    var calcCta = parseInt(window.scrollY + cta.offsetHeight);

    if (document.getElementsByClassName('page-header-title')[0]) {
      var left = parseInt(document.getElementsByClassName('page-header-title')[0].getBoundingClientRect().left);
      var top = parseInt(text.getBoundingClientRect().top + window.scrollY);

      containerCta.style.position = 'absolute';
      containerCta.style.top = top + 'px';
      //if scrolling past element, then make it fixed
      if (window.scrollY > (top - siteHeader.offsetHeight)) {
        containerCta.style.position = 'fixed';
        containerCta.style.top = '90px';
        containerCta.style.left = left + 'px';

        //make sure it doesn't scroll over the footer

          if (calcFooter < calcCta) {
            containerCta.style.position = 'absolute';
            // cta.style.bottom =  '230px';
            containerCta.style.top = '';
          }
      }

    } else {
      var left = parseInt(document.getElementsByClassName('form-container')[0].getBoundingClientRect().left);
      var side = document.getElementsByClassName('sideText')[0];
      var top = parseInt(side.getBoundingClientRect().top + side.offsetHeight + parseInt(window.getComputedStyle(side).getPropertyValue('margin-bottom')) + window.scrollY);
      containerCta.style.position = 'absolute';
      containerCta.style.top = top + 'px';

      //if scrolling past element, then make it fixed
      if (window.scrollY > (top - siteHeader.offsetHeight)) {
        containerCta.style.position = 'fixed';
        containerCta.style.top = '90px';
        containerCta.style.left = left + 'px';

      }
    }

  }

  prevScrollpos = currentScrollPos;

    if (document.getElementsByClassName('cursorScroll')[0]) {
    var cursor = document.getElementsByClassName('cursorScroll')[0];

    mouseIcon();
    if (currentScrollPos >= 0) {
  		cursor.classList.add('show');
  	} else {
  		cursor.classList.remove('show');
  	}

  }

  function mouseIcon() {
    //mouse scroll icon function
    //calculate if last slide and then remove
    //calculate color
    let sections = document.getElementsByTagName('section');
		// let lastSection = document.querySelectorAll('section:last-child');
		//give last section a class
		sections[sections.length-1].classList.add('lastSection');

    Array.from(sections).map(function(s) {
      var position = s.getBoundingClientRect();

      // checking whether fully visible
      if (position.top >= 0 && position.bottom <= window.innerHeight) {
        if (s.classList.contains('bg-secondary') || s.classList.contains('section-home-background')) {
          cursor.classList.add('green');
        } else {
          cursor.classList.remove('green');
        }
      }

      // checking for partial visibility
      if (position.top < window.innerHeight && position.bottom >= 0) {
        if (s.classList.contains('bg-secondary') || s.classList.contains('section-home-background')) {
          cursor.classList.add('green');
        } else {
          cursor.classList.remove('green');
        }

				if(s.classList.contains('lastSection')){
					cursor.style.opacity = '0';
				} else {
					cursor.style.opacity = '';
				}
      }


    });
  }

}

window.onload = function(e) {
  if (document.body.classList.contains('bg-primary')) {
    var mobileBar = document.getElementsByClassName("mobile-bar")[0];

    mobileBar.classList.remove('bg-transparent');
    mobileBar.classList.add('bg-light');
  }

  //tabs mobile
  if (document.getElementsByClassName('tabs-mobile')[0]) {
    var tab = document.getElementsByClassName('tab-mobile');

    Array.from(tab).map(function(t) {
      t.addEventListener('click', function(e) {
        var currentId = e.target.id;

        if (document.getElementsByClassName(currentId)[0].classList.contains('active')) {
          document.getElementsByClassName(currentId)[0].classList.remove('active');
          document.getElementById(currentId).classList.remove('active');

        } else {
          document.getElementsByClassName(currentId)[0].classList.add('active');
          document.getElementById(currentId).classList.add('active');
        }
      })
    })
  }
  if (document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('page-header-title')[0] || document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('form-container')[0] ) {
    var cta = document.getElementsByClassName('ctas')[0];
    var containerCta = document.getElementsByClassName('container-cta')[0];

    if ( document.getElementsByClassName('page-header-title')[0]) {
      var left = parseInt(document.getElementsByClassName('page-header-title')[0].getBoundingClientRect().left);
      //grab the left position
      containerCta.style.left = left + 'px';
    } else{
      var left = parseInt(document.getElementsByClassName('form-container')[0].getBoundingClientRect().left);
      //grab the left position
      containerCta.style.left = left + 'px';
    }

    //show cta when exists and loaded
    setTimeout(showCta, 1000);

    function showCta() {
      cta.style.opacity = 1;
    }
  }
  window.onscroll();

}

window.onresize = function(e) {
  //make sure the left position is still correct on resize
  if (document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('page-header-title')[0]) {
    var containerCta = document.getElementsByClassName('container-cta')[0];
    var left = parseInt(document.getElementsByClassName('page-header-title')[0].getBoundingClientRect().left);
    containerCta.style.left = left + 'px';
  }

  if (document.getElementsByClassName('ctas')[0] && document.getElementsByClassName('form-container')[0] ) {
    var containerCta = document.getElementsByClassName('container-cta')[0];
    var left = parseInt(document.getElementsByClassName('form-container')[0].getBoundingClientRect().left);
    containerCta.style.left = left + 'px';
  }

}
